<template>
  <div class="px-10px pt-10px text-14px flex flex-col h-full">
    <div class="flex-shrink-0">
      <!-- 原有内容 -->
      <div class="h-160px border border-hex-4d9bbf border-solid relative pt-35px px-18px">
        <div
          class="h-25px w-60px flex items-center justify-center text-hex-03ffec border-1px border-solid border-hex-03ffec rounded-2px absolute right-0 top-0 bg-hex-0e1e26 text-12px"
        >
          人员详情
        </div>
        <div class="h-100px flex text-white">
          <div class="w-100px h-full mr-15px">
            <img
              v-if="personnelDetail.avatar"
              class="w-full h-full object-contain border border-gray-500/20"
              :src="personnelDetail.avatar ? personnelDetail.avatar : ''"
              alt
            />
            <div
              v-else
              class="h-full w-full"
              :class="[personnelDetail.gender === 1 ? 'male' : 'female']"
            ></div>
          </div>
          <div class="flex flex-col justify-between">
            <div class="flex">
              <div class="text-hex-45f2eb mr-5px">姓名</div>
              <div class="max-w-100px truncate" :title="personnelDetail.name">
                {{ personnelDetail.name }}
              </div>
            </div>
            <div class="flex">
              <div class="text-hex-45f2eb mr-5px">部门</div>
              <div class="max-w-100px truncate" :title="personnelDetail.department">
                {{ personnelDetail.department }}
              </div>
            </div>
            <div class="flex">
              <div class="text-hex-45f2eb mr-5px">岗位</div>
              <div class="max-w-100px truncate" :title="personnelDetail.post">
                {{ personnelDetail.post }}
              </div>
            </div>
            <div class="flex">
              <div class="text-hex-45f2eb mr-5px">手机号码</div>
              <div class="max-w-100px truncate" :title="personnelDetail.phoneNumber">
                {{ personnelDetail.phoneNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex text-white text-16px justify-between my-15px flex-shrink-0">
      <div
        class="flex items-center justify-center w-90px h-33px cursor-pointer"
        :class="currentBtn === 'locationTracking' && isFollow ? 'btn_choosed' : 'btn_normal'"
        @click="track"
      >
        {{ isFollow ? '取消追踪' : '位置追踪' }}
      </div>
    </div>

  </div>
</template>

<script>
import { WorkTicketsApi, OperationSecurityApi } from '@wiz-api/huizhou2-business'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import { FileApi } from '@wiz-api/file-management'
import { PersonnelApi } from '@wiz-api/personnel-position'
import { Tag3DCameraPositionsApi } from '@wiz-api/iot-device-management'
import {
  isEmpty,
  head,
  find,
  filter,
  map,
  forEach,
  get,
  isEqual,
  cloneDeep,
  toInteger,
} from 'lodash'

const tag3DCameraPositionsApi = new Tag3DCameraPositionsApi()
const operationSecurityApi = new OperationSecurityApi()
const workTicketsApi = new WorkTicketsApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
const fileApi = new FileApi()
const personnelApi = new PersonnelApi()

export default {
  props: {
    player: {
      type: Object,
    },
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
    onlineTagList: {
      type: Array,
      default: () => {
        return []
      },
    },
    allLineList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      oldLabelList: [],
      personnelDetail: {
        name: '',
        avatar: null,
        department: '',
        post: '',
        phoneNumber: '',
        gender: 1,
      },
      isFollow: false,
      personChangeTimer: null,
      // 默认跟随
      currentBtn: '',
      // 所有人员的信息
      allPersonnelInfo: [],
      // 附近的人列表
      nearbyList: [],
      // code和id的映射
      codeIdMap: {},
      nearByPage: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      // 处理数据的标识
      flag: true,
      // 是否查看历史轨迹
      isTrajectory: false,
      // 智能两票
      twoTicketList: [],
      twoTicketPage: {
        pageNo: 1,
        pageSize: 8,
        total: 0,
      },
      // 附近摄像头列表
      cameraList: [],
      detailDialogShow: false,
      pdfBase64: null,
      currentMonitor: null,
      currentPosition: null,
      nowCamera: null,
      followTimer: null,
    }
  },
  computed: {
    personnelId() {
      return this.transferProps?.personnelId
        ? this.transferProps?.personnelId
        : this.customProps?.personnelId
    },
    tagCode() {
      return this.transferProps?.tagCode ? this.transferProps?.tagCode : this.customProps?.tagCode
    },
    // 前端分页处理
    showNearbyList() {
      return this.nearbyList.slice(
        (this.nearByPage.pageNo - 1) * this.nearByPage.pageSize,
        this.nearByPage.pageNo * this.nearByPage.pageSize
      )
    },
    // 附近的人最大距离筛选
    nearMaxDistance() {
      return (
        get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.nearMaxDistance || 1000
      )
    },
    // 当前项目
    curProj() {
      return (
        get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.curProj || ''
      )
    },
  },
  watch: {
    transferProps: {
      immediate: true,
      async handler(value) {
        // 如果是从历史轨迹的人员标签打开的人员详情弹框
        if (value.isTrajectory) {
          this.currentBtn = 'trajectory'
          this.isTrajectory = true
          if (this.isFollow) {
            // 取消跟随
            await this.cloudRender.PosViewer.cancelPerspectiveFollow()
            this.isFollow = false
            if (this.followTimer) {
              clearInterval(this.followTimer)
              this.followTimer = null
            }
            this.currentMonitor = null
          }
        } else if (value.isFollow === true || value.isFollow === undefined) {
          // 如果不是从历史轨迹中点击标签打开的，则跟随人员
          if (!this.isFollow) {
            await this.cloudRender.PosViewer.setPerspectiveFollow({
              id: this.tagCode,
              personalPerspective: 2,
              angle: [5, 90],
            })
            this.isFollow = true
          }
          this.currentBtn = 'locationTracking'
        }
        await this.getPersonnelDetail(this.personnelId)
      },
    },
    currentBtn(value) {
      if (value === 'trajectory') {
        // 打开历史轨迹的弹框
        this.$emit('operateTrajectory', {
          visible: true,
          personnelId: this.personnelId,
          tagCode: this.tagCode,
        })
      }
    },
    labelList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.propLabelList = _.cloneDeep(value)
      },
    },
    tagCode: {
      handler(newTagCode, oldTagCode) {
        // 当tagCode改变时，触发positionListHandler
        if (newTagCode !== oldTagCode) {
          this.positionListHandler()
        }
      },
    },
  },
  async created() {
    await this.getPersonnelDetail(this.personnelId)
  },
  mounted() {
    // 监听实时人员数据更新的事件
    // window.addEventListener('setNearByList', this.positionListHandler)
    // 监听取消跟随的时间
    window.addEventListener('cancelFollow', this.cancelFollowHandler)
    // 监听是否查看历史轨迹事件
    window.addEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    this.cloudRender.Dispatch.on('PosViewerMarker', this.markerClick)
  },
  methods: {
    // 初始化打开人员标签
    getLabel(ifstart) {
      const displayLabelList = filter(this.oldLabelList, (item) => {
        if (ifstart) {
          if (item.code === 'PersonnelList') {
            return true
          }
          return false
        }
        if (item.checked) {
          return true
        }
      })
      const newLabelList = map(this.oldLabelList, (item) => {
        if (ifstart) {
          if (item.code === 'PersonnelList') {
            return {
              ...item,
              checked: true,
            }
          }
        }
        return {
          ...item,
        }
      })
      const displayEvent = new CustomEvent('setComponentVisible', {
        detail: {
          type: 'display',
          displayLabelList,
          newLabelList,
        },
      })
      window.dispatchEvent(displayEvent)
    },
    markerClick(e) {
      // 左键点击并且有id
      if (e.type === 1 && !isEmpty(e.id)) {
        if (this.tagCode === e.id) {
          this.currentBtn = 'locationTracking'
          this.isFollow = true
        }
      }
    },
    // 获取附近摄像头列表
    async getCameraList() {
      // 根据tagCode在onlineTagList中查找对应人员的坐标
      const onlinePerson = this.allLineList.find((person) => {
        return person.tagId === this.tagCode
      })

      if (!onlinePerson) {
        console.warn('未找到对应的人员坐标信息')
        return
      }

      const [err, res] = await tag3DCameraPositionsApi.getNearbyCameras({
        _number: 20,
        x: onlinePerson.x,
        y: onlinePerson.y,
      })
      if (!err) {
        // 限制不超过20条
        this.cameraList = (res || []).map((item) => {
          return {
            ...item,
            distance: toInteger(item.distance),
          }
        })
      }
    },
    // 获取人员详情信息
    async getPersonnelDetail(personnelId) {
      const [err, res] = await eafOrganizationUnitUserApi.getUserDetail({ id: personnelId })
      if (!err && !isEmpty(res)) {
        this.personnelDetail.name = res.name
        this.personnelDetail.phoneNumber = res.phoneNumber
        this.personnelDetail.post = head(res.userPosts)?.postName
        this.personnelDetail.department = head(res.orgUnits)?.organizationUnitName
        this.personnelDetail.gender = res.extraProperties.Gender
        if (!isEmpty(res.extraProperties?.Avatar)) {
          this.personnelDetail.avatar = await this.getImgContent(res.extraProperties?.Avatar)
        }
      }
    },
    // 获取图片base64
    async getImgContent(fileId) {
      // 获取图片内容
      const [error, result] = await fileApi.getPublicImageBaseString(fileId)
      if (!error && !isEmpty(result)) {
        return `data:image/png;base64,${result.base64}`
      }
      return ''
    },
    // 获取附近摄像头
    async getNearbyCamera() {
      const CamP = await this.player.Native.Camera.currentParam()
      const [err, res] = await tag3DCameraPositionsApi.getNearbyCameras({
        x: CamP.target[0],
        y: CamP.target[1],
        _number: 5,
      })
      if (!err) {
        if (res.length && !isEqual(this.currentMonitor, res[0])) {
          this.currentMonitor = null
          this.currentMonitor = res[0]
        } else {
          this.currentMonitor = null
        }
      }
    },
    // 跟随操作
    async track() {
      if (this.isTrajectory) {
        this.$message.warning({
          showClose: true,
          message: '请先退出轨迹查询',
        })
        return
      }
      this.currentBtn = 'locationTracking'
      this.detailDialogShow = false
      if (this.isFollow) {
        if (this.followTimer) {
          clearInterval(this.followTimer)
          this.followTimer = null
        }
        this.currentMonitor = null
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      } else {
        const label = find(this.labelList, ['code', 'PersonnelList'])
        if (!label.checked) {
          this.$message.warning({
            showClose: true,
            message: '没有勾选人员标签，请先勾选',
          })
          return
        }
        // 跟随人员
        await this.cloudRender.PosViewer.setPerspectiveFollow({
          id: this.tagCode,
          personalPerspective: 2,
          angle: [5, 90],
        })
        await this.getNearbyCamera()
        this.followTimer = setInterval(async () => {
          await this.getNearbyCamera()
        }, 30000)
      }
      this.isFollow = !this.isFollow
    },
    // 获取所有人员信息
    async getAllPersonnelInfo() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        includeOrgChild: true, // 是否查询该部门子部门人员
        skipCount: 0,
        maxResultCount: 5000,
      })
      if (!err && !isEmpty(res)) {
        this.allPersonnelInfo = res.items
      }
    },
    // 获取code和id的映射
    async getCodeIdMap() {
      const [err, res] = await personnelApi.getPersonnelPostionList({
        isBind: true,
        skipCount: 0,
        maxResultCount: 5000,
      })
      if (!err && !isEmpty(res)) {
        forEach(res, (item) => {
          this.codeIdMap[item.tagCode] = item.id
        })
      }
    },
    // 点击附近的人
    async nearbyPeople() {
      if (this.isTrajectory) {
        this.$message.warning({
          showClose: true,
          message: '请先退出轨迹查询',
        })
        return
      }
      // 获取附近的人时如果处于跟随状态，则取消跟随
      this.currentBtn = this.currentBtn !== 'peopleNearby' ? 'peopleNearby' : ''
      this.detailDialogShow = false
      if (this.isFollow) {
        this.isFollow = false
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
    },
    async searcheTrajectory() {
      this.currentBtn = 'trajectory'
      this.detailDialogShow = false
      if (this.isFollow) {
        this.isFollow = false
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
    },
    // 监听获取实时定位人员数据
    positionListHandler() {
      if (isEmpty(this.allLineList)) return

      // 仅读取 this.allLineList，不做任何修改
      // 获取当前人员的位置（只读遍历）
      let currentInfo = null
      const targetCode = String(this.tagCode).trim()
      for (let i = 0; i < this.allLineList.length; i += 1) {
        const it = this.allLineList[i]
        if (String(it.tagId).trim() === targetCode) {
          currentInfo = it
          break
        }
      }
      this.currentPosition = currentInfo
      if (isEmpty(currentInfo)) return

      // 预建人员详情映射，避免循环内多次查找；不修改源数据
      const detailById = new Map()
      for (let i = 0; i < this.allPersonnelInfo.length; i += 1) {
        const d = this.allPersonnelInfo[i]
        detailById.set(String(d.id), d)
      }
      // 单次只读遍历，按距离阈值直接构建 nearbyList
      const nearby = []
      for (let i = 0; i < this.allLineList.length; i += 1) {
        const item = this.allLineList[i]
        const itemTag = String(item.tagId).trim()
        if (itemTag !== targetCode) {
          const mappedId = this.codeIdMap[itemTag]
          const detail = mappedId != null ? detailById.get(String(mappedId)) : null
          if (detail) {
            const dx = (Number(item.x) || 0) - (Number(currentInfo.x) || 0)
            const dy = (Number(item.y) || 0) - (Number(currentInfo.y) || 0)
            const dz = (Number(item.z) || 0) - (Number(currentInfo.z) || 0)
            const distanceVal = Math.hypot(dx, dy, dz)
            if (distanceVal <= this.nearMaxDistance) {
              nearby.push({
                id: detail.id,
                tagCode: itemTag,
                name: detail.name,
                department: detail.orgUnits?.[0]?.organizationUnitName,
                distance: distanceVal.toFixed(2),
              })
            }
          }
        }
      }
      this.nearbyList = nearby
      this.nearByPage.total = nearby.length
    },
    // 附近的人切换页码
    handlePageChange(val) {
      this.nearByPage.pageNo = val
    },
    // 获取附近的人某个人的详情并跟随
    async getDetail(item) {
      // 跟随该人员
      await this.cloudRender.PosViewer.setPerspectiveFollow({
        id: item.tagCode,
        personalPerspective: 2,
        angle: [5, 90],
      })
      this.isFollow = true
      this.currentBtn = 'locationTracking'
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'PersonnelInfo',
            origin: 'tag',
            name: '人员信息',
          },
          type: 'tags',
          props: {
            personnelId: item.id,
            tagCode: item.tagCode,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    async cancelFollowHandler() {
      if (this.isFollow) {
        this.isFollow = false
        // 取消跟随
        await this.cloudRender.PosViewer.cancelPerspectiveFollow()
      }
    },
    // 监听是否查看历史轨迹
    historicalTrajectoryHandler(e) {
      this.isTrajectory = e.detail?.isOpen
      if (!e.detail?.isOpen && this.currentBtn === 'trajectory') this.currentBtn = ''
    },
    // 获取工作票列表
    async getList() {
      // 天生港屏蔽工作票内容
      if (this.curProj === 'TSG') return
      const [err, res] = await workTicketsApi.getMyWorkTicket({
        body: {
          pageNo: this.twoTicketPage.pageNo,
          pageSize: this.twoTicketPage.pageSize,
          name: this.personnelDetail.name,
        },
      })
      if (!err) {
        this.twoTicketList = res.items
        this.twoTicketPage.total = res.totalCount
      }
    },
    // 查看详情
    handleDetail(item) {
      this.nowCamera = item
      this.detailDialogShow = true
    },
    // 获取工作票文件
    async getTicketFile(id) {
      const [err, res] = await operationSecurityApi.getTicketFileAync({
        businessId: id,
      })
      if (!err) {
        const blob = new Blob([res], { type: 'application/pdf' })
        this.getBolb(blob)
      }
    },
    getBolb(file) {
      // 假设pdfBlob是从后端获取的PDF文件流
      const pdfBlob = file // 从后端获取的PDF文件流
      const reader = new FileReader()
      reader.onload = () => {
        const base64Data = reader.result
        // 在这里可以将base64data发送到后端或者用于前端展示
        this.pdfBase64 = base64Data
      }
      reader.readAsDataURL(pdfBlob)
      this.detailDialogShow = true
    },
  },
  beforeDestroy() {
    // 解绑事件
    // window.removeEventListener('setNearByList', this.positionListHandler)
    window.removeEventListener('cancelFollow', this.cancelFollowHandler)
    window.removeEventListener('HistoricalTrajectory', this.historicalTrajectoryHandler)
    this.cloudRender.Dispatch.off('PosViewerMarker', this.markerClick)
    if (this.isFollow) {
      // 取消跟随
      this.cloudRender.PosViewer.cancelPerspectiveFollow()
    }
    if (this.personChangeTimer) {
      clearInterval(this.personChangeTimer)
      this.personChangeTimer = null
    }
    if (this.followTimer) {
      clearInterval(this.followTimer)
      this.followTimer = null
    }
  },
}
</script>

<style lang="scss" scoped>
.male {
  background: url('../../../assets/images/control/headerImg-male.png');
  background-size: 100% 100%;
}

.female {
  background: url('../../../assets/images/control/headerImg-female.png');
  background-size: 100% 100%;
}

.btn_normal {
  background: url('../../../assets/images/button_blue.png');
  background-size: 100% 100%;
}

.btn_choosed {
  background: url('../../../assets/images/button_yellow.png');
  background-size: 100% 100%;
}
</style>
